export default "skymp5-front/8725285acc017513ed15441d664312d7.svg";